/* Two-column drawer layout */

.drawerLayout {
    display: flex;
    align-items: stretch;
    height: 100%;
    overflow: hidden;
}

.connectorSidebar {
    flex: 0 0 240px;
    padding: var(--exo-spacing-medium);
    border-radius: var(--exo-radius-large);
    background: var(--exo-color-background-secondary);
    display: flex;
    flex-direction: column;
    gap: var(--exo-spacing-small);
    margin-bottom: var(--exo-spacing-medium);
}

.connectorSidebarWithBack {
    padding-top: var(--exo-spacing-2x-small);
}

.connectorSidebarName {
    font: var(--exo-text-headline-2-bold);
}

.connectorSidebarDescription {
    font-size: var(--exo-font-size-small);
    color: var(--exo-color-font-secondary);
    line-height: var(--exo-line-height-body);
}

.formColumn {
    flex: 1;
    padding: var(--exo-spacing-large);
    min-width: 0;
    overflow-y: auto;
}

.connectorIcon {
    flex-shrink: 0;
    border-radius: 12px;
    padding: var(--exo-spacing-x-small);
    background: var(--exo-color-background);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.credentialsSpacing {
    margin-top: var(--exo-spacing-medium);
}

.header {
    display: block;
    margin-bottom: var(--exo-spacing-medium);
}

:global(.ex-theme-dark) .connectorIcon {
    background: #f0f0f0;
    border: 1px solid rgba(0, 0, 0, 0.06);
}

.drawerMainContent {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
